<template lang="pug">
  div(id="2GisMap", :style="mapStyles")
</template>

<script>
export default {
  name: 'Map',
  props: {
    points: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    map: null,
    marker: null,
    mapStyles: {
      width: '100%',
      height: '400px'
    }
  }),
  created() {
    this.initMap()
  },
  watch: {
    async points(value) {
      if (value) {
        await this.moveMap(value)
        await this.setPin({
          lat: this.points.latitude,
          lng: this.points.longitude
        })
      }
    }
  },
  methods: {
    initMap() {
      const DG = require('2gis-maps')
      DG.then(() => {
        this.map = DG.map('2GisMap', {
          center: [this.points.latitude, this.points.longitude],
          zoom: 10,
          zoomControl: true,
          fullscreenControl: true,
          dragging: true,
          scrollWheelZoom: false
        })
        DG.control.location({ position: 'bottomright' }).addTo(this.map)
        if (this.points) {
          this.moveMap(this.points)
          this.setPin({
            lat: this.points.latitude,
            lng: this.points.longitude
          })
        }
      })
    },
    setPin(coords) {
      const DG = require('2gis-maps')
      if (this.marker) this.marker.remove()
      this.map.setView(coords, 12)
      this.marker = DG.marker(coords, { draggable: true })
        .addTo(this.map)
        .on('dragend', e => {
          this.$store.commit('SET_MARKER_COORDS', e.target._latlng)
        })
    },
    moveMap(coords) {
      this.map.setView([coords.latitude, coords.longitude], 10)
    }
  }
}
</script>
